import { useState, useEffect } from 'react'

const COUNTDOWN_TIME = 10 * 60 + 43 // 10 minutes 43 seconds

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(COUNTDOWN_TIME)

  useEffect(() => {
    let endTime = sessionStorage.getItem('offerEndTime')
    if (!endTime) {
      endTime = (Date.now() + COUNTDOWN_TIME * 1000).toString()
      sessionStorage.setItem('offerEndTime', endTime)
    }

    const updateTimer = () => {
      const now = Date.now()
      const remaining = Math.max(
        0,
        Math.floor((parseInt(endTime as string) - now) / 1000),
      )
      setTimeLeft(remaining)
      return remaining
    }

    updateTimer()
    const interval = setInterval(() => {
      const remaining = updateTimer()
      if (remaining === 0) {
        clearInterval(interval)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60

  return {
    minutes,
    seconds,
    formatted: `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`,
  }
}
